import { IconActionSearch16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './MobileSearchBlock.css';
import clsx from 'clsx';
import { Experiment } from '@cian/experiments/ab';

interface ISearchBlockProps {
  text?: string;
  placeholder?: string;
  isMainpage: boolean;
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const MobileSearchBlock: React.FC<ISearchBlockProps> = ({
  onSearchClick,
  text,
  isMainpage,
  placeholder = 'Например, купить квартиру в Москве',
}) => {
  return (
    <>
      <Experiment name="aud_mobile_bx925_redesign_mainpage_header" group="A" default>
        <div className={styles['container']} data-name="MobileSearchBlock">
          <a
            href="/nd/search/"
            className={clsx(styles['button'], styles['geo-button'], !text && styles['placeholder'])}
            onClick={onSearchClick}
          >
            <span className={styles['icon']}>
              <IconActionSearch16 />
            </span>
            <span className={styles['text']}>{text || placeholder}</span>
          </a>
        </div>
      </Experiment>
      <Experiment name="aud_mobile_bx925_redesign_mainpage_header" group="B">
        <div
          className={clsx(styles['container'], isMainpage && styles['container--mainpage-redesign'])}
          data-name="MobileSearchBlock"
        >
          <a
            href="/nd/search/"
            className={clsx(
              styles['button'],
              styles['geo-button'],
              !text && styles['placeholder'],
              isMainpage && styles['button--mainpage-redesign'],
            )}
            onClick={onSearchClick}
          >
            <span className={styles['icon']}>
              <IconActionSearch16 />
            </span>
            <span className={styles['text']}>{text || placeholder}</span>
          </a>
        </div>
      </Experiment>
      <Experiment name="aud_mobile_bx925_redesign_mainpage_header" group="C">
        <div
          className={clsx(styles['container'], isMainpage && styles['container--mainpage-redesign'])}
          data-name="MobileSearchBlock"
        >
          <a
            href="/nd/search/"
            className={clsx(
              styles['button'],
              styles['geo-button'],
              !text && styles['placeholder'],
              isMainpage && styles['button--mainpage-redesign'],
            )}
            onClick={onSearchClick}
          >
            <span className={styles['icon']}>
              <IconActionSearch16 />
            </span>
            <span className={styles['text']}>{text || placeholder}</span>
          </a>
        </div>
      </Experiment>
    </>
  );
};
